import { render } from "./BaseRow.vue?vue&type=template&id=49c6e34b&scoped=true"
import script from "./BaseRow.vue?vue&type=script&lang=js"
export * from "./BaseRow.vue?vue&type=script&lang=js"

import "./BaseRow.vue?vue&type=style&index=0&id=49c6e34b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49c6e34b"

export default script